<template>
  <div>
    <ListingLayout
      show-date
      date-selected="last_30_days"
      :product-options="['oem', 'cso']"
      :filter-names="['search']"
      search-label="search"
      :show-data-table="false"
      @filterOption="onFiltersChange"
    >
      <template #description>
        <div>
          <users-tabs-index :filters="{ ...options, ...customFilters }" />
        </div>
      </template>
      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-autocomplete
            v-model="customFilters.platform"
            filled
            dense
            :items="platformOptions"
            item-value="key"
            item-text="label"
            :label="$t('platform')"
            @change="fetchData"
          />
        </v-card>
        <v-card>
          <v-autocomplete
            v-model="customFilters.payment_method"
            filled
            dense
            :items="paymentOptions"
            item-value="key"
            item-text="label"
            :label="$t('payment_method')"
            @change="fetchData"
          />
        </v-card>
        <v-card>
          <v-autocomplete
            v-model="customFilters.user_segment"
            filled
            dense
            :items="userSegmentOptions"
            item-value="key"
            item-text="label"
            :label="$t('user_segment')"
            @change="fetchData"
          />
        </v-card>
      </template>
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="loading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <!-- <template #actionModals>
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    UsersTabsIndex: () => import("./tabs/UsersTabsIndex.vue"),
  },
  mixins: [ListingLayoutMixins],
  props: {},

  data() {
    return {
      permissions: {
        view: "",
        create: "",
        edit: "",
        delete: "",
      },
      //
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      filters: {},
      subFilters: {},
      //
      customFilters: {
        platform: "all",
        payment_method: "all",
        user_segment: "all",
      },
      //
      platformOptions: [
        { key: "all", label: "All" },
        { key: "android", label: "Android" },
        { key: "ios", label: "IOS" },
      ],
      paymentOptions: [
        { key: "all", label: "All" },
        { key: "cash", label: "Cash" },
        { key: "card", label: "Card" },
        { key: "in-app", label: "In App" },
      ],
      userSegmentOptions: [
        { key: "all", label: "All" },
        { key: "occasional", label: "Occasional" },
        { key: "regular", label: "Regular" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      loading: "usersAnalyticsDashboard/getLoading",
      meta: "usersAnalyticsDashboard/getMeta",
      list: "usersAnalyticsDashboard/getList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: true,
          value: "charge_point_id",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Severity",
          align: "left",
          sortable: true,
          value: "severity_level",
        },
        {
          text: this.$t("notes"),
          align: "left",
          sortable: false,
          value: "notes",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "status",
        },
        {
          text: this.$t("closing_status"),
          align: "left",
          sortable: false,
          value: "closing_status",
        },
        {
          text: this.$t("remaining_time"),
          align: "left",
          sortable: true,
          value: "remaining_time",
        },
        {
          text: this.$t("reports"),
          align: "left",
          sortable: false,
          value: "reports",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return [];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "users_analytics_dashboard",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };
      await this.$store
        .dispatch("usersAnalyticsDashboard/list", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
